// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoClickUpInbox, {type ClickUpNotification} from '@app/features/konvo_notifications/state/KonvoClickUpInbox';

export function handleKonvoClickUpInboxUpdate(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	const update = data as Partial<{items: unknown; cleared_through: unknown}>;
	if (Array.isArray(update.items)) KonvoClickUpInbox.applyUpdate({items: update.items as Array<ClickUpNotification>});
	else if (typeof update.cleared_through === 'string')
		KonvoClickUpInbox.applyUpdate({cleared_through: update.cleared_through});
}
